<template>
  <modal :show="show">
    <div slot="modalHeader">
      <modal-header :closeModal="close">Cloning Encoding Profile - {{ name }}</modal-header>
    </div>
    <div class="form-group">
      <div class="field">
        <form-group>
          <field name="Clone Encoding Profile Name" value="" v-model="cloneEncodingProfileName" :error="error"/>
        </form-group>
      </div>
    </div>
    <div slot="modalFooter">
      <modal-footer :closeModal="close" :confirm="confirm" cancelText="Cancel" confirmText="Yes"/>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {encodingProfileMixin} from '@/mixins/encodingProfileMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'

export default {
  name: 'modal_clone_encoding_profile',
  mixins: [modalMixin, encodingProfileMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    FormGroup,
    Field
  },
  props: {
    show: Boolean,
    id: String,
    name: String
  },
  data: () => ({
    cloneEncodingProfileName: '',
    error: ''
  }),
  mounted () {
  },
  computed: {},
  methods: {
    confirm () {
      if (!this.cloneEncodingProfileName) {
        this.error = 'This value should not be blank.'
        return
      }
      this.startLoading()
      this.cloneEncodingProfile({id: this.id, name: this.cloneEncodingProfileName}).then(() => {
        this.addNotification('success', `Encoding Profile cloned successfully.`)
        this.getEncodingProfiles().then(() => {
          this.finishLoading()
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/encoding-profile/modal-clone-encoding-profile.vue